import { find, findIndex, slice } from 'lodash-es'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import menu from '@/assets/dataModel/menu'
import storage from '@/shared/storage'
import { vm } from '@/main'
import store from '@/store'
import { getHomeRoute } from '@/shared/untils'
import { otherRoutes } from './otherRoutes'
import { sidebarRoutes } from './sidebar'
import { logout } from '@/request'
import emc from '@/assets/dataModel/EnumModelContainer'

export { sidebarRoutes, otherRoutes }

export const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/t',
    name: 't',
    meta: { title: '登录', keepAlive: false, requireAuth: false, routerKey: 't', visible: true },
    component: () => import(/* webpackChunkName: "login" */ '@/views/widget/Login.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录', keepAlive: false, requireAuth: false, routerKey: 'login', visible: true },
    component: () => import(/* webpackChunkName: "login" */ '@/views/widget/Login.vue'),
  },
  {
    path: '/login/adminUserlogin',
    name: 'root-login',
    meta: { title: '登录', keepAlive: false, requireAuth: false, routerKey: 'login', visible: true },
    component: () => import(/* webpackChunkName: "login" */ '@/views/widget/RootLogin.vue'),
  },
  {
    path: '/account-setting',
    name: 'login-account-setting',
    meta: { title: '账号设置', keepAlive: false, requireAuth: false, routerKey: 'account-setting', visible: true },
    component: () => import(/* webpackChunkName: "login" */ '@/views/widget/account-setting.vue'),
  },
  {
    path: '/choose-org',
    name: 'choose-org',
    meta: { title: '选择机构', keepAlive: false, requireAuth: false, routerKey: 'choose-org', visible: true },
    component: () => import(/* webpackChunkName: "login" */ '@/views/widget/choose-org.vue'),
  },
  {
    path: '/login2',
    name: 'login2',
    meta: { title: '登录', keepAlive: false, requireAuth: false, routerKey: 'login2', visible: true },
    component: () => import(/* webpackChunkName: "login" */ '@/views/widget/Login.vue'),
  },
  {
    path: '/simple-report',
    name: 'simple-report',
    meta: {
      title: '简单报告',
      keepAlive: false,
      requireAuth: false,
      routerKey: 'simple-report',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "simple-report" */ '@/views/setting/simpleReport.vue'),
  },
  {
    path: '/',
    name: 'root',
    meta: { title: '首页', keepAlive: false, requireAuth: true, visible: false },
    component: () => import(/* webpackChunkName: "layout" */ '@/views/widget/Layout.vue'),
    children: [...sidebarRoutes, ...otherRoutes],
  },
  {
    path: '/401',
    name: '401',
    meta: { title: '401', keepAlive: false, requireAuth: true, visible: false },
    component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/401.vue'),
  },
  {
    path: '/404',
    name: '404',
    meta: { title: '404', keepAlive: false, requireAuth: true, visible: false },
    component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/404.vue'),
  },
  {
    path: '/under-maintenance',
    name: 'under-maintenance',
    meta: { title: ' 网站维护中', keepAlive: false, requireAuth: false, visible: true },
    component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/under-maintenance.vue'),
  },

  {
    path: '/:catchAll(.*)',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes: commonRoutes,
})
// 生成现有路由路径对应的权限名
const permission = [...sidebarRoutes, ...otherRoutes].reduce((obj: Record<string, any>, item) => {
  // xxx: 过滤param，后续改成非params路由，更好作权限判断
  const filter = item.path.match(/(:.+)/)
  if (filter) {
    const path = item.path.replace(/(:.+)/, '')
    obj[path + 'view'] = item.meta.routerKey
    obj[path + 'edit'] = item.meta.routerKey
    obj[path + 'add'] = item.meta.routerKey
    return obj
  }
  obj[item.path] = item.meta.routerKey
  return obj
}, {})

const routerHasMetaList = [...sidebarRoutes, ...otherRoutes, ...commonRoutes].filter((item) => {
  item.meta
})
// 无需登录的路径
const notAuthList = routerHasMetaList.filter((item) => !item.meta.requireAuth).map((item) => item.path)

// 根据code转name的图
const permissionNameMap: any = menu.getSidebarRouteMap()
// // 根据后端提供的权限code转换为name的方法
const getCachePermissionName = (cacheList: any) => {
  const list = cacheList ? cacheList.list : null
  if (!list) return []
  return list.map((item: any) => permissionNameMap[item.menuId])
}

router.beforeEach(async (to, from, next) => {
  /**
   * 在react子应用中切换路由 再切换其他主应用时失败。报错
   *
   *  Error with push/replace State DOMException: Failed to execute 'replaceState' on 'History':
   *  A history state object with URL 'http://localhost:8023undefined/' cannot be created in a document with origin 'http://localhost:8023' and URL 'http://localhost:8023/app-react/test'.
   *
   *  解决历程：
   *  首先使用vue-router 跳转 失败，报以上错。
   *  不知道什么原因，然后使用原生qiankun 封装的原生js跳转 报一样的错误。于是打印每次跳转时路由的数据结构，发现在react中切换路由之后 currnet state 没有值。但是在切回vue其他子应用路由由vue-router接管以后，
   *  是需要根据history.state.current值的，所以在在导航首位中判断是否有current，没有就加上from.fullpath。
   *
   *
   */
  if (!history.state.current) {
    Object.assign(history.state, {
      current: from.fullPath,
    })
  }

  if (to.path === '/t') {
    location.href = '/pece/same-screen-code'
    return
  }

  // 解决,用户没有获取到配置文件的问题
  if (!sessionStorage.getItem('tbl_sch_run_type')) {
    if (emc) {
      emc.getRefTable()
    }
  }
  const permissionCache = storage.get('permission')
  const account = vm.$store.getters.getAccount
  const isNeedAuth = to.meta.requireAuth
  // 如果是直接进入根目录默认进入到有权限的第一个菜单中.
  if (from.fullPath === '/' && to.fullPath === '/') {
    if (isNeedAuth && !account.token && to.name !== 'login') {
      return next({ name: 'login' })
    }
    return next(getHomeRoute())
  }
  // 解析cache中的list，转换为name
  const authList = getCachePermissionName(permissionCache)
  // 转换to路径为权限对应的类别
  const transferPath = permission[to.path]
  if (isNeedAuth && !account.token && to.name !== 'login') {
    return next({ name: 'login' })
    // } else if (to.meta.blank) {
    //   window.open(to.meta.blank as string, '_blank')
    //   return next()
  } else {
    return next()
  }
})

router.afterEach(async (to, from) => {
  // 记录刷新前的跳转前路由 (刷新时 from 会是根目录, 此时不需要变更上一个路由).
  if (from.fullPath !== '/') {
    store.commit('setLastRouter', {
      fullPath: from.fullPath,
      path: from.path,
      query: from.query,
      hash: from.hash,
      name: from.name,
      meta: from.meta,
      params: from.params,
    })
  }
  if (to.name === 'archives-detail') {
    to.meta.title = (to.query.selfName || '用户') + '的档案'
  }
  if (to.name === 'open-seas-archives-detail') {
    to.meta.title = (to.query.selfName || '用户') + '的档案'
  }
  /**
   * isSidebarRoute 参数用于标记要进入的路由是否属于左侧菜单栏中的一级路由.
   */
  const isSidebarRoute = !!find(sidebarRoutes, { name: to.name })
  store.commit('setIsSidebarRoute', isSidebarRoute)

  /**
   * 自动设置面包屑逻辑.
   *
   * 1. 要进入的路由是属于左侧菜单栏的一级路由, 用 isSidebarRoute 参数控制面包屑只显示机构名, 覆盖面包屑, 只保留一级路由面包屑数据.
   * 2. 要进入的路由不属于左侧菜单栏的一级路由, 并且在面包屑中已存在, 则面包屑中将此路由后面的面包屑删除 (用于覆盖从更深层次路由直接点击前面的面包屑进入前面的路由的情况).
   * 3. 要进入的路由不属于左侧菜单栏的一级路由, 在面包屑中不存在, 直接添加到面包屑中.
   */
  if (to.meta.ignoreCrumbs !== true) {
    // @ts-ignore
    const crumbs = store.state.common.crumbs
    const toRouterInSidebarRouterIdx = findIndex(crumbs, { name: to.name })
    if (isSidebarRoute) {
      store.commit('setCrumbs', [{ name: to.name, title: to.meta?.title || '', query: to.query }])
    } else if (toRouterInSidebarRouterIdx !== -1) {
      // to 路由在面包屑中存在, 则面包屑中将此路由后面的面包屑删除.
      store.commit('setCrumbs', slice(crumbs, 0, toRouterInSidebarRouterIdx + 1))
    } else {
      store.commit('addCrumb', {
        name: to.name,
        title: to.meta?.title || '',
        query: to.query,
      })
    }
  }
})

export default router
